import {registerCommonPopup} from '@/commons/popupRegister/commonPopupRegister.js';
import {registerDictionary} from '@/commons/popupRegister/dictionaryRegister.js';
import {registerLedger} from '@/commons/popupRegister/ledgerRegister.js';
import {registerBusinessPopup} from '@/commons/popupRegister/businessPopupRegister'
import { registerAsset } from './popupRegister/assetRegister';
import {registerDeposit} from '@/commons/popupRegister/depositRegister';
import {registerDistribution} from '@/commons/popupRegister/distributionRegister.js';
import {registerSummary} from '@/commons/popupRegister/summaryRegister.js';
import {registerSystem} from '@/commons/popupRegister/systemRegister.js';
import {registerReport} from '@/commons/popupRegister/reportRegister.js';
import {registerInitialBalance} from '@/commons/popupRegister/initialBalanceRegister.js';
import {registerDigitalSign} from '@/commons/popupRegister/digitalSignRegister.js';
import {registerEtreasury} from '@/commons/popupRegister/etreasuryRegister.js';

export function register(app) {
  registerCommonPopup(app);
  registerDictionary(app);
  registerBusinessPopup(app);
  registerAsset(app);
  registerDeposit(app);
  registerDistribution(app);
  registerLedger(app);
  registerSummary(app);
  registerSystem(app);
  registerReport(app);
  registerInitialBalance(app);
  registerDigitalSign(app);
  registerEtreasury(app);
}
